import React from "react";
import { LeftOutlined } from "@ant-design/icons"; // Ant Design icon
import { useNavigate } from "react-router-dom"; // For React Router navigation
import './style.css'
export default function BackButton({ text = "ย้อนกลับ", style }) {
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate(-1)}
            className="back-button"
            style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#fd0088",
                color: "white",
                fontSize: "clamp(14px, 1.8vw, 18px)",
                fontWeight: "bold",
        
                borderRadius: "25px",
                border: "none",
                cursor: "pointer",
                transition: "transform 0.2s ease-in-out",
                textDecoration: "none",
                whiteSpace: "nowrap",
                ...style,
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
            <span className="back-button-icon">
                <LeftOutlined style={{ fontSize: "14px" }} />
            </span>
            <span className="back-button-text">
                {text}
            </span>
        </button>
    );
}